module.exports = __webpack_public_path__ + "img/sellflux.64886f17.png";